const GAM_ADS_URL = '//pubads.g.doubleclick.net/gampad/ads';
export function buildAdTagUrl(adTagParameters) {
    const url = window.location.protocol?.includes('http')
        ? new URL(GAM_ADS_URL, window.location.href)
        : new URL(`https:${GAM_ADS_URL}`);
    if (adTagParameters) {
        url.search = new URLSearchParams(adTagParameters).toString();
    }
    return url.toString();
}
